var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { riSearchControl: true, accented: _vm.accented } },
    [
      _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.term,
                expression: "term"
              }
            ],
            ref: "input",
            attrs: { type: "text", readonly: !_vm.accented },
            domProps: { value: _vm.term },
            on: {
              keypress: _vm.onSearch,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.term = $event.target.value
              }
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "searchIcon",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.onSearch($event)
            }
          }
        },
        [_c("SearchIcon")],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }